const FILTERS = {
    "hcp-cloud":{
        isv: {
            title: 'ISV Name',
            icon: 'server.png'
        },
        isv_application: {
            title: 'ISV Application Name',
            icon: 'os.png'
        },
        isv_application_version: {
            title: 'ISV Application Version',
            icon: 'os_kernel.png'
        },
        hcp_for_cloud_scale_version: {
            title: 'HCP for Cloud Scale Version',
            icon: 'hba_driver.png'
        },
        interface: {
            title: 'Interface',
            icon: 'array_if.png'
        }
    }
}
export default FILTERS;